import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../Constants";
import history from "../../history";
import { updateUtilisateur } from "../connexion/connexionSlice";

// État initial pour la slice listeRestaurants
const initialState = {
  restaurants: [],
  selectedRestaurant: null,
  status: "idle", // "idle", "loading", "succeeded", "failed"
  error: null,
};

const listRestaurantsSlice = createSlice({
  name: "listeRestaurants",
  initialState,
  reducers: {
    setRestaurants(state, action) {
      state.restaurants = action.payload;
    },
    selectRestaurant(state, action) {
      state.selectedRestaurant = action.payload;
    },
    clearRestaurants(state) {
      state.restaurants = [];
      state.selectedRestaurant = null;
      state.status = "idle";
      state.error = null;
    },
    // Actions pour suivre l'état de l'opération manuelle
    patchSelectedRestaurantStart(state) {
      state.status = "loading";
    },
    patchSelectedRestaurantSuccess(state) {
      state.status = "succeeded";
    },
    patchSelectedRestaurantFailure(state, action) {
      state.status = "failed";
      state.error = action.payload;
    },
  },
});

export const {
  setRestaurants,
  selectRestaurant,
  clearRestaurants,
  patchSelectedRestaurantStart,
  patchSelectedRestaurantSuccess,
  patchSelectedRestaurantFailure,
} = listRestaurantsSlice.actions;

// Thunk manuel pour patcher le restaurant sélectionné (sans createAsyncThunk)
export const patchSelectedRestaurant = (selectedRestaurantPayload) => {
  return async (dispatch, getState) => {
    // Cas spécial : si un superadmin sélectionne "Administration"
    if (selectedRestaurantPayload.restaurant.restaurants_affichage === "admin") {
      // Mettre à jour l'état utilisateur avec les informations d'administration
      dispatch(updateUtilisateur({ 
        rest_id_affichage: "admin", 
        rest_nom: "Administration",
        rest_id: "admin"
      }));
      dispatch(patchSelectedRestaurantSuccess());
      history.push("/admin");
      return;
    }

    dispatch(patchSelectedRestaurantStart());
    const config = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    };

    try {
      const response = await axios.patch(
        API_URL + "/compte/connexion/alias",
        selectedRestaurantPayload,
        config
      );

      // Récupération des données retournées, y compris le nouveau csrf_token
      const { id, alias, rest_id, rest_id_affichage, rest_nom, jti, csrf_token } = response.data;

      // Mise à jour du state de connexion avec les nouvelles informations
      dispatch(updateUtilisateur({ id, alias, rest_id, rest_id_affichage, rest_nom, jti, csrf_token }));

      dispatch(patchSelectedRestaurantSuccess());
      history.push("/dashboard");

      return response.data;
    } catch (error) {
      dispatch(patchSelectedRestaurantFailure(error.response ? error.response.data : error.message));
      throw error;
    }
  };
};

// Thunk pour récupérer tous les restaurants pour les superadmins
export const fetchSuperAdminRestaurants = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${API_URL}/compte/superadmin/restaurants`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      
      let restaurantsList = response.data.restaurants;
      
      // Ajouter l'option Administration en premier
      restaurantsList.unshift({
        restaurants_affichage: "admin",
        restaurants_nom: "Administration",
        restaurants_id: "admin"
      });
      
      dispatch(setRestaurants(restaurantsList));
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des restaurants:', error);
      throw error;
    }
  };
};


export const listeRestaurantsSelector = (state) => state.listeRestaurants;
export default listRestaurantsSlice.reducer;
